module.exports = __webpack_public_path__ + "img/slide-description.50003ebd.png";